import Link from 'next/link';

interface FooterServerProps {
  currentLanguage?: 'en' | 'de';
}

const FooterServer = ({ currentLanguage = 'en' }: FooterServerProps) => {
  const translations = {
    en: {
      copyright: '© 2026 Planet Pulse Studios. All rights reserved.',
      imprint: 'Imprint',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
    },
    de: {
      copyright: '© 2026 Planet Pulse Studios. Alle Rechte vorbehalten.',
      imprint: 'Impressum',
      privacy: 'Datenschutzerklärung',
      terms: 'AGB',
    },
  };

  const t = translations[currentLanguage];

  return (
    <footer className="relative bg-primary border-t border-border mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:relative">
          {/* Left: Copyright */}
          <div className="text-foreground-light text-sm font-inter text-center md:text-left">
            <p>{t.copyright}</p>
          </div>

          {/* Center: Social Media */}
          <div className="flex justify-center items-center gap-4 md:absolute md:left-1/2 md:-translate-x-1/2">
            <a
              href="https://www.linkedin.com/in/stefan-artmann-8a561b27/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent hover:text-[#16c55f] transition-colors duration-fast"
              aria-label="LinkedIn Profile"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a
              href="mailto:stefanartmann@planetpulsestudios.com"
              className="text-accent hover:text-[#16c55f] transition-colors duration-fast"
              aria-label="Send Email"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m2 7 10 7 10-7" />
              </svg>
            </a>
          </div>

          {/* Right: Legal Links */}
          <nav className="flex flex-wrap items-center justify-center md:justify-start gap-4 text-sm font-inter">
            <Link
              href="/imprint"
              prefetch={false}
              className="text-foreground-light hover:text-highlight transition-colors duration-fast"
            >
              {t.imprint}
            </Link>
            <Link
              href="/privacy"
              prefetch={false}
              className="text-foreground-light hover:text-highlight transition-colors duration-fast"
            >
              {t.privacy}
            </Link>
            <Link
              href="/terms"
              prefetch={false}
              className="text-foreground-light hover:text-highlight transition-colors duration-fast"
            >
              {t.terms}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default FooterServer;